/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import {
  Divider,
  Tooltip,
} from '@material-ui/core';
import { useLocation, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import AllSitesTable from './AllSitesTable';
import {
  CommonPagination,
  ScreenContainer,
  CommonButton,
} from '../../CommonComponents';
import {
  getAllSites,
  getSitesDataByEstimateId,
  updatePrimaryQuery,
} from '../../redux/actions/sites';
import SitesFilter from '../../CommonComponents/SitesFilter/SitesFilter';
import PrimaryFilters from '../../CommonComponents/PrimaryFilters';
import FallbackCard from '../../CommonComponents/FallbackCard';
import {
  exportCompeteSiteReports, exportSites, importSites,
} from '../../redux/actions/common';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const AllSites = ({
  getAllSitesAction,
  totalSitePages,
  updateQuery,
  primaryQuery,
  searchQuery,
  fetchSites,
  exportSite,
  exportCompleteSites,
  importSite,
}) => {
  const query = useQuery();
  const history = useHistory()
  const page = parseInt(query.get('page') || '1', 10);
  const [showSites, enableSites] = useState(false);
  const [estimateId, setEstimateId] = useState(null)
  const [selected, setSelected] = useState([]);
  const [checkBoxState, setCheckbox] = React.useState(true);
  const [selectedStartDate, setSelectedStartDate] = useState('');

  useEffect(() => {
    const pno = query.get('page')
    if (showSites && pno) { getAllSitesAction(page, searchQuery, primaryQuery); }
  }, [query, getAllSitesAction, searchQuery, primaryQuery, showSites, page]);

  const fetchAllSite = (val) => {
    setSelectedStartDate('')
    setSelected([]);
    setCheckbox(true);
    setEstimateId(val)
    if (query.has('estimateId')) {
      query.set('estimateId', val)
    } else {
      query.append('estimateId', val)
    }
    query.delete('page')
    history.push('/all-sites')
    updateQuery(query.toString())
    fetchSites(val);
    enableSites(true);
  }

  const exportData = () => {
    exportSite(estimateId)
  }

  const handleChange = (files) => {
    importSite(files[0], estimateId)
  }

  const userType = JSON.parse(localStorage.getItem('user'));
  return (
    <ScreenContainer title="All Sites">
      <PrimaryFilters
        visibleProduct
        visibleEstimate
        fetchFunction={fetchAllSite}
        location="allsites"
        showFetchButton

      />
      <br />
      {estimateId && userType && (userType.userType === 'admin' || userType.userType === 'manager')
        ? (
          <div className="row">
            <div className="col-12">
              <CommonButton
                onClick={() => exportData()}
                basic="true"
                color="primary"
              >
                <b>Export Sites</b>
              </CommonButton>
              <input
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                style={{ display: 'none' }}
                id="import-sites"
                onChange={(e) => handleChange(e.target.files)}
                type="file"
              />
              <Tooltip disableFocusListener title="Please make sure you have already created monitor before mapping." placement="right" arrow>
                <label htmlFor="import-sites">
                  <CommonButton
                    variant="raised"
                    component="span"
                  >
                    <b className="text-primary">Import Sites</b>
                  </CommonButton>
                </label>
              </Tooltip>
              <CommonButton
                onClick={() => exportCompleteSites(estimateId)}
                basic="true"
                className="float-right"
                color="primary"
              >
                <b>Export Detailed Reports</b>
              </CommonButton>
            </div>
          </div>
        )
        : null}
      {showSites
        ? (
          <>
            <SitesFilter currentLocation="all-sites" setSelected={setSelected} />
            <div className="row">
              <Divider />
              <div className="col-12">
                <br />
                <AllSitesTable
                  setSelected={setSelected}
                  selected={selected}
                  setCheckbox={setCheckbox}
                  checkBoxState={checkBoxState}
                  selectedStartDate={selectedStartDate}
                  setSelectedStartDate={setSelectedStartDate}
                />
                {totalSitePages > 1 ? (
                  <CommonPagination
                    baseUrl="all-sites"
                    totalPages={totalSitePages}
                  />
                ) : null}
                <br />
                <br />
              </div>
            </div>
          </>
        )
        : <FallbackCard text="Fetch the sites to start" />}
    </ScreenContainer>
  );
};

const mapState = (state) => ({
  totalSitePages: state.sites.totalSitePages,
  searchQuery: state.sites.searchQuery,
  primaryQuery: state.sites.primaryQuery,
});

const mapActions = {
  getAllSitesAction: getAllSites,
  fetchSites: getSitesDataByEstimateId,
  updateQuery: updatePrimaryQuery,
  exportSite: exportSites,
  exportCompleteSites: exportCompeteSiteReports,
  importSite: importSites,
};

export default connect(mapState, mapActions)(AllSites);
